import { Box, Skeleton } from '@mui/material';

export const ExternalAccountsSkeleton = () => {
  const accountsCounts = [1, 11, 3, 2];
  return (
    <Box>
      {accountsCounts.map((count) => (
        <Box key={count}>
          <Skeleton
            variant="rounded"
            sx={{ fontSize: '2.4rem', width: '28rem' }}
          />
          <Box sx={{ m: '1rem 0 3rem 2rem' }}>
            {Array.from({ length: count }).map((_, i) => (
              <Skeleton key={i} sx={{ fontSize: '1.8rem', width: '18rem' }} />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
